import "./About.scss";

const About = ({ setCursorVariant }) => {
  const objectEnter = () => {
    setCursorVariant("sword");
  };
  const objectLeave = () => {
    setCursorVariant("default");
  };

  return (
    <div id="about" className="about-wrapper" data-scroll-section>
      <div className="headline">
        <h1 className="subtitle" data-scroll data-scroll-speed="2">
          Story of my life
        </h1>
        <div></div>
        <div className="headline-wrapper">
          <div className="headline-group">
            <div className="headline-outline" data-scroll data-scroll-speed="1">
              about
            </div>
            <div className="headline-text" data-scroll data-scroll-speed="2">
              about
            </div>
            <div className="headline-outline" data-scroll data-scroll-speed="3">
              about
            </div>
          </div>
        </div>
      </div>
      <div className="about-body">
        <div />
        <div
          className="my-image"
          data-scroll
          data-scroll-speed="3"
          onMouseEnter={objectEnter}
          onMouseLeave={objectLeave}
          style={{ backgroundImage: "url(./assets/my1.jpeg)" }}
        ></div>
        <div className="my-desc" data-scroll data-scroll-speed="3">
          My name is Vaibhav Dhiman, and I'm a Vancouver-based developer
          experienced in JavaScript technologies. Working experience in building
          complex web apps using JavaScript technologies such as React, Express,
          Node, and MongoDB. With a wide range of skills, I offer a diverse
          range of approaches to every project to find the best way to present
          it. Working together to achieve a common goal and learning from others
          has always been exciting to me. For any project you require my help,
          feel free to get in touch with me.
        </div>
      </div>
    </div>
  );
};

export default About;
